import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { payeePropTypes } from '../../../sharedComponents/PayeeList/propTypes';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import pageContent from '../IFTPayments/iftPayments.content';
import { getInternationalPayees } from '../../../states/payees/selectors';
import { goToPage, pages } from '../../../states/page/actions';
import { clearSelectedPayment } from '../../../states/payeeSelector/actions';
import PayeesPage from '../../../sharedComponents/PayeesPage/PayeesPage';
import {
	getSelectedPaymentId,
	getSelectedFromAccount,
	getFromAccountCanPayBenificiaries,
} from '../../../states/payeeSelector/selectors';
import { iftAddPayments, continueToPaymentDetails } from '../../../states/ift/actions';
import { getAccountsWithIFTCapability } from '../../../states/accounts/selectors';
import { PAYMENTS_LIMIT } from '../../../config';

const mapState = (state) => ({
	toPayees: getInternationalPayees(state),
	selectedPaymentId: getSelectedPaymentId(state),
	fromAccount: getSelectedFromAccount(state),
	canPayBeneficiaries: getFromAccountCanPayBenificiaries(state),
	fromAccounts: getAccountsWithIFTCapability(state),
});

const mapDispatch = (dispatch) => ({
	addPayments: (fromAccount, toAccounts) => dispatch(iftAddPayments({ fromAccount, toAccounts })),
	continueToPayments: () => dispatch(goToPage(pages.IFTPayments)),
	continueToPaymentDetails: () => dispatch(continueToPaymentDetails),
	clearSelectedPayment: () => dispatch(clearSelectedPayment()),
});

class IFTPayeePage extends Component {
	constructor(props) {
		super(props);

		this.handlePayeeListContinue = this.handlePayeeListContinue.bind(this);
	}

	handlePayeeListContinue(selectedToPayees) {
		const { addPayments, continueToPayments, continueToPaymentDetails, fromAccount } = this.props;

		addPayments(fromAccount, selectedToPayees);
		if (selectedToPayees.length === 1) return continueToPaymentDetails();
		return continueToPayments();
	}

	render() {
		const {
			toPayees,
			content: { header },
			content,
			paymentCount,
			canPayBeneficiaries,
			fromAccounts,
			handleDisplayFullwidth,
		} = this.props;

		return (
			<PayeesPage
				toPayees={toPayees}
				header={header}
				description=""
				content={content}
				paymentCount={paymentCount}
				onPayeeListContinue={this.handlePayeeListContinue}
				updateFromAccount={() => {}}
				showAccounts={false}
				canPayBeneficiaries={canPayBeneficiaries}
				fromAccounts={fromAccounts}
				paymentLimit={PAYMENTS_LIMIT}
				handleDisplayFullwidth={handleDisplayFullwidth}
			/>
		);
	}
}

IFTPayeePage.propTypes = {
	content: PropTypes.shape({}).isRequired,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)).isRequired,
	continueToPayments: PropTypes.func.isRequired,
	continueToPaymentDetails: PropTypes.func.isRequired,
	addPayments: PropTypes.func.isRequired,
	paymentCount: PropTypes.number.isRequired,
	fromAccount: PropTypes.string,
	canPayBeneficiaries: PropTypes.bool,
	fromAccounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	handleDisplayFullWidth: PropTypes.func,
};

export default compose(
	withScrollTop,
	withContent({ content: pageContent }),
	connect(mapState, mapDispatch)
)(IFTPayeePage);
